import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
} from "@mui/material";
import StoreSearch from "../../../Campaign/StoreSearch.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import OrgName from "../../../../../shared/assets/icons/OrgName.png";
import VendorIcon from "../../../../../shared/assets/icons/VendorIcon.png";
import BatchActions from "../ManufactureActionButton";
import styles from "../../JobBatch.module.css";
import moment from "moment";
import axios from "axios";
import { useParams } from "react-router-dom";

const NotAccepted = ({ onClusterChange }) => {
  const [expandedCluster, setExpandedCluster] = React.useState(null);
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const { id } = useParams();
  const [clusters, setClusters] = React.useState([]);
  const [clusterLoading, setClusterLoading] = useState(false);
  const batchRefs = useRef({});
  const containerRef = useRef(null);

  const handleAccordionToggle = (clusterTitle, batchTitle) => (event) => {
    event.stopPropagation();
    if (clusterTitle) {
      setExpandedCluster((prev) =>
        prev === clusterTitle ? null : clusterTitle,
      );
    }
    if (batchTitle) {
      setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
    }
  };

  // Helper function to calculate total jobs in a cluster
  const calculateTotalJobsInCluster = (cluster) => {
    return cluster.batches.reduce(
      (total, batch) => total + (batch.jobs?.length || 0),
      0,
    );
  };

  // fetch Jobs
  // const fetchAllJobsBasedOnCampaignId = async (id) => {
  //   setClusterLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL}/jobs/getAllJobs?campaignId=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     if (response?.data?.success) {
  //       // setAvailableJobs(response.data.data);
  //       fetchAllBatchesBasedOnCampaignId(response.data.data, id);
  //     }
  //   } catch (error) {
  //     setClusterLoading(false);

  //     console.error("error in while fetching jobs", error);
  //   }
  // };
  // fetch batches
  // const fetchAllBatchesBasedOnCampaignId = async (jobs, id) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL}/batchOfJobs/getAllBatchesForVendor?campaignId=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     if (response?.data?.success) {
  //       const updatedBatches = await response?.data?.data.map((batch) => ({
  //         ...batch,
  //         jobs: [],
  //       }));

  //       // First, check if campaign has Recce phase by looking at jobs
  //       const hasReccePhase = jobs.some((job) => job.jobApprovalStatus);

  //       // Include jobs based on campaign type
  //       jobs?.forEach((job) => {
  //         const batch = updatedBatches.find(
  //           (batch) => batch._id === job.batchOfJobsForVendorId
  //         );

  //         if (batch) {
  //           if (hasReccePhase) {
  //             // For Recce phase - only include approved jobs
  //             if (job?.jobApprovalStatus?.clientStatus === 1) {
  //               batch.jobs.push(job);
  //             }
  //           } else {
  //             // For Manufacturing phase - include all jobs
  //             batch.jobs.push(job);
  //           }
  //         }
  //       });
  //       // setAvailableBatches(updatedBatches);
  //       fetchAllClustersBasedOnCampaignId(updatedBatches, id);
  //     }
  //   } catch (error) {
  //     setClusterLoading(false);

  //     console.error("error in while fetching jobs", error);
  //   }
  // };
  // fetch clusters
  const fetchAllClustersBasedOnCampaignId = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/manufacturingJobs/notAcceptedVendorClusters?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        // Filter for not accepted clusters (no vendorId assigned)
        const updatedClusters = await response?.data?.data
          .filter((cluster) => !cluster.vendorId)
          .map((cluster) => ({
            ...cluster,
            batches: [],
          }));
        // updatedBatches?.forEach((batch) => {
        //   const cluster = updatedClusters.find(
        //     (cluster) => cluster._id === batch.idOfClusterOfBatchesForVendor
        //   );
        //   if (cluster) {
        //     cluster.batches.push(batch);
        //   }
        // });

        // Additional filter to remove clusters with no batches
        // const filteredClusters = updatedClusters.filter(
        //   (cluster) => cluster.batches.length > 0
        // );

        // Sort clusters by createdAt in descending order (newest first)
        // const sortedClusters = filteredClusters.sort((a, b) => {
        //   return new Date(b.createdAt) - new Date(a.createdAt);
        // });

        setClusters(response.data.data);
        onClusterChange(response.data.data.length);
        setClusterLoading(false);
      }
    } catch (error) {
      setClusterLoading(false);

      console.error("error in while fetching jobs", error);
    }
  };

  useEffect(() => {
    fetchAllClustersBasedOnCampaignId(id);
  }, [id]);

  const DataRow = ({ row }) => (
    <TableRow>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeName}</div>
        <div
          className={styles.address2}
        >{`${row?.address},${row?.city},${row?.state}-${row?.zipCode}`}</div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeOwnerName}</div>
        <div className={styles.storeManagerContact}>
          {row?.storeOwnerPhoneNumber}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {`${
            row?.product?.approvedWidth ?? row?.product?.productWidth ?? "N/A"
          } * 
         ${
           row?.product?.approvedHeight ?? row?.product?.productHeight ?? "N/A"
         } * 
         ${row?.product?.productThickness ?? "N/A"}`}
        </div>
      </TableCell>
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.baseMaterial || "N/A"}
        </div>
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.printDetails || "N/A"}
        </div>
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        {row?.product?.printImage ? (
          <div className={styles.iconLinkContainer}>
            <a
              href={row.product.printImage}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
            >
              <div className={styles.pdfIconWithText}>
                <img
                  src="/assests/AdminDashboard/pdfImage.png"
                  alt="Print File"
                  className={styles.pdfIcon}
                />
              </div>
            </a>
          </div>
        ) : (
          <div className={styles.sharedTextStyle}>No print file</div>
        )}
      </TableCell> */}
      {/* <TableCell className={styles.tableCell}>
        {row?.materialDetailsForFabrication?.cadFile ? (
          <div className={styles.iconLinkContainer}>
            <a
              href={row.materialDetailsForFabrication.cadFile}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
            >
              <div className={styles.pdfIconWithText}>
                <img
                  src="/assests/AdminDashboard/pdfImage.png"
                  alt="CAD File"
                  className={styles.pdfIcon}
                />
              </div>
            </a>
          </div>
        ) : (
          <div className={styles.sharedTextStyle}>No CAD file</div>
        )}
      </TableCell> */}
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.product?.productType || "N/A"}
        </div>
      </TableCell>
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row.oemPreference || "N/A"}
        </div>
      </TableCell> */}
    </TableRow>
  );

  const searchData = useMemo(() => {
    const result = [];

    clusters.forEach((cluster) => {
      cluster.batches?.forEach((batch) => {
        batch.jobs?.forEach((job) => {
          result.push({
            id: job._id,
            storeName: job.storeName,
            clusterTitle: cluster.clusterTitle,
            batchTitle: batch.batchTitle,
            targetId: batch._id,
            subText: `${cluster.clusterTitle} → ${batch.batchTitle}`,
          });
        });
      });
    });

    return result;
  }, [clusters]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div
        className="mx-3 py-2 sticky top-0 z-20 bg-white"
        
      >
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedCluster(item.clusterTitle);

            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {clusterLoading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : clusters.length === 0 ? (
        <div className={styles.noJobsStyle}>
          <Box className={styles.noJobsBox}>
            <p className={styles.noJobsText}>
              No clusters of batches is available
            </p>
          </Box>
        </div>
      ) : (
        clusters.map((cluster, index) => (
          <Grid item xs={12} md={12} key={index} my={1} mx={2}>
            <Accordion expanded={expandedCluster === cluster.clusterTitle}>
              <AccordionSummary
                expandIcon={
                  <IconButton
                    onClick={handleAccordionToggle(cluster.clusterTitle)}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                }
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
                className={styles.accordionHeader}
              >
                <div className={styles.batchHeader}>
                  <div className={styles.clusterTitle}>
                    {cluster.clusterTitle}
                  </div>
                  <div className={styles.chipContainer}>
                    <Chip
                      label={`Batches: ${cluster.totalNumberOfBatches || 0}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={`Jobs: ${cluster.totalNumberOfJobs}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={`Timeline: ${moment(
                        cluster.jobStartingDate,
                      ).format("DD MMM YY")} - ${moment(
                        cluster.jobCompletionDate,
                      ).format("DD MMM YY")}`}
                      className={styles.chip}
                    />
                    {/* <button className={styles.ellipsisButton}>⋮</button> */}
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails className={styles.accordionDetails}>
                <Box className={`${styles.scrollableBox}`}>
                  {cluster.batches.map((batch, batchIndex) => (
                    <div
                      ref={(el) => {
                        batchRefs.current[batch._id] = el;
                      }}
                    >
                      <Accordion
                        expanded={expandedBatch === batch.batchTitle}
                        key={batchIndex}
                        className={`${styles.accordionCustom}`}
                      >
                        <AccordionSummary
                          expandIcon={
                            <IconButton
                              onClick={handleAccordionToggle(
                                null,
                                batch.batchTitle,
                              )}
                            >
                              <ExpandMoreIcon />
                            </IconButton>
                          }
                          aria-controls={`panel-${batchIndex}-content`}
                          id={`panel-${batchIndex}-header`}
                        >
                          <div className={styles.batchHeader}>
                            <h1 className={styles.batchTitle}>
                              {batch.batchTitle}
                            </h1>
                            <div className={styles.chipContainer}>
                              <Chip
                                label={`Jobs: ${batch.jobs?.length || 0}`}
                                className={styles.chip}
                              />
                              {/* <Chip
                                                            label={batch.status}
                                                            classes={{
                                                                root: batch.status === "PDI Status: PDI Requested"
                                                                    ? styles.pdiRequested
                                                                    : batch.status === "PDI Status: PDI Approved"
                                                                        ? styles.pdiApproved
                                                                        : styles.pending
                                                            }}
                                                        /> */}
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className={styles.accordionDetails}>
                          <Box className={`${styles.scrollableBox}`}>
                            <TableContainer
                              component={Paper}
                              className={styles.tableContainer}
                            >
                              <Table>
                                <TableHead>
                                  <TableRow className={styles.tableHeader}>
                                    <TableCell className={styles.tableCell}>
                                      DELIVERY ADDRESS
                                    </TableCell>
                                    <TableCell className={styles.tableCell}>
                                      STORE MANAGER
                                    </TableCell>
                                    <TableCell className={styles.tableCell}>
                                      DIMENSIONS (W×H×T)
                                    </TableCell>
                                    {/* <TableCell className={styles.tableCell}>
                                    BASE MATERIAL
                                  </TableCell> */}
                                    <TableCell className={styles.tableCell}>
                                      PRODUCT TYPE
                                    </TableCell>
                                    {/* <TableCell className={styles.tableCell}>
                                    PRINT IMAGE
                                  </TableCell> */}
                                    {/* <TableCell className={styles.tableCell}>
                                    CAD FILE
                                  </TableCell> */}
                                    {/* <TableCell className={styles.tableCell}>
                                        OEM PREFERENCE
                                      </TableCell> */}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {batch?.jobs?.map((row, rowIndex) => (
                                    <DataRow key={rowIndex} row={row} />
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  ))}
                </Box>
              </AccordionDetails>
              {/* <BatchActions /> */}
            </Accordion>
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default NotAccepted;
